import { useEffect, useState } from "react";
import * as helper from '../global/helper';
import { postGreenFeeCalendar } from "../api/teeTimeAPI";

const AddGreenFeeCalendar = (props) => {

    const [calendarDetails, setCalendarDetails] = useState({
        Name: '',
        StartDate: '',
        EndDate: ''
    });

    useEffect(() => {
        if (props.calendarData && props.isEdit) {
            setCalendarDetails({
                Name: props.calendarData.Name || '',
                StartDate: props.calendarData.StartDate || '',
                EndDate: props.calendarData.EndDate ||''
            });
        } else {
            setCalendarDetails({
                Name: '',
                StartDate: '',
                EndDate: ''
            });
        }
    }, [props.calendarData, props.isEdit]);

    useEffect(() => {
        if (props.show) {
            $('#add-green-fee-calendar-modal').modal({
                backdrop: 'static',
            });
            $('#add-green-fee-calendar-modal').modal('show');

            $('#txtStartDate').datepicker({
                format: 'dd-mm-yyyy',
                autoclose: true,
                minDate: new Date()
            });
            $('#txtStartDate').on('change', function (event) {
                updateCalendarDetails('StartDate', moment(event.target.value, 'DD-MM-YYYY').format('YYYY-MM-DD'));
            });

            $('#txtEndDate').datepicker({
                format: 'dd-mm-yyyy',
                autoclose: true
            });
            $('#txtEndDate').on('change', function (event) {
                updateCalendarDetails('EndDate', moment(event.target.value, 'DD-MM-YYYY').format('YYYY-MM-DD'));
            });
        }
        $('#add-green-fee-calendar-modal').on('hidden.bs.modal', function () {
            $('.modal').hasClass('show') && $('body').addClass('modal-open');
            props.onDismissModal && props.onDismissModal(false);
        });
    }, [props.show]);

    const closeModal = () => {
        $('#add-green-fee-calendar-modal').modal('hide');
    };

    const updateCalendarDetails = (field, value) => {
        setCalendarDetails((d) => {
            return { ...d, [field]: value };
        });
    };

    const handleSave = async (e) => {
        e.preventDefault();

        const btn = $('#btnSave');
        var form = $('#add-green-fee-calendar-form');

        form.validate({
            rules: {
                txtName: {
                    required: true
                },
                txtStartDate: {
                    required: true
                },
                txtEndDate: {
                    required: true
                }
            },
            messages: {
                txtName: {
                    required: "Please enter calendar name"
                },
                txtStartDate: {
                    required: "Please select Start Date"
                },
                txtEndDate: {
                    required: "Please select End Date"
                }
            }
        });

        if (!form.valid()) return;
        helper.StartProcessing(btn);
        try {
            if (props.isEdit) {
                // update calendar
                await postGreenFeeCalendar({
                    ...calendarDetails, ID: props.calendarData.ID
                });
            } else {
                // add new calendar
                await postGreenFeeCalendar(calendarDetails);
            }
            helper.StopProcessing(btn);
            $('#add-green-fee-calendar-modal').modal('hide');
            swal.fire({
                icon: 'success',
                titleText: props.isEdit ? 'Calendar updated successfully' : 'Calendar added successfully',
                showConfirmButton: false,
                timer: 1500,
            });
            props.refetchCalendars();
        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
        }
    };

    return (
        <>
            <div className="modal fade" id="add-green-fee-calendar-modal" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add GreenFee Calendar</h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                onClick={closeModal} 
                            >
                            </button>
                        </div>
                        <div className="modal-body">
                            <form className="kt-form" id="add-green-fee-calendar-form">
                                <div id="ControlHolder" className="kt-form padding-10" role="form">
                                    {/* Name */}
                                    <div className="form-group row mb-4">
                                        <label className="col-form-label col-lg-3 text-left">Name</label>
                                        <div className="col-lg-9" style={{paddingLeft: "0.75rem"}}>
                                            <input
                                                id="txtName"
                                                name="txtName"
                                                type="text"
                                                className="form-control"
                                                value={calendarDetails.Name}
                                                onChange={(event) => updateCalendarDetails('Name', event.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* Start date */}
                                <div className="form-group row">
                                    <label className="col-form-label col-lg-3">Start Date</label>
                                    <div className="col-lg-9">
                                        <div className="input-group date">
                                            <input
                                            id="txtStartDate"
                                            name="txtStartDate" 
                                            type="text" 
                                            className="form-control date-input"
                                            readOnly={true}
                                            value={moment(calendarDetails.StartDate).format('DD-MM-YYYY')}
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* End date */}
                                <div className="form-group row">
                                    <label className="col-form-label col-lg-3">End Date</label>
                                    <div className="col-lg-9">
                                        <div className="input-group date">
                                            <input
                                            id="txtEndDate"
                                            name="txtEndDate" 
                                            type="text" 
                                            className="form-control date-input"
                                            readOnly={true}
                                            value={moment(calendarDetails.EndDate).format('DD-MM-YYYY')}
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                                onClick={closeModal}
                            >
                                Cancel
                            </button>
                            <button
                                id="btnSave"
                                type="button"
                                className="btn btn-brand"
                                onClick={handleSave}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddGreenFeeCalendar